import { render } from "./qs-sxpr-gwp-view.vue?vue&type=template&id=ecfceea0"
import script from "./qs-sxpr-gwp-view.vue?vue&type=script&setup=true&lang=js"
export * from "./qs-sxpr-gwp-view.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/tep/tep-nsi/qs-sxpr-gwp-view.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ecfceea0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ecfceea0', __exports__)) {
    api.reload('ecfceea0', __exports__)
  }
  
  module.hot.accept("./qs-sxpr-gwp-view.vue?vue&type=template&id=ecfceea0", () => {
    api.rerender('ecfceea0', render)
  })

}


export default __exports__